import {toDate} from './date';

global.raft= {
	supplyInfo:{},
	customizableElements : [
		{
			id:"Sail Colors",
			title:"Sail Color",
			options:[
				{ layerId:"Plain Sail", title:"Plain"},
				{ layerId:"Purple Sail", title:"Purple"},
				{ layerId:"Yellow Sail", title:"Yellow"},	  
				{ layerId:"Orange Sail", title:"Orange"},
				{ layerId:"Green Sail", title:"Green"},
				{ layerId:"Blue Sail", title:"Blue"},
				{ layerId:"Red Sail",  title:"Red"}				  
			]
		},	
		{
			id:"Sail Characters",
			title:"Sail Character",
			options:[
				{ layerId:"None", title:"None" },
				{ layerId:"Vita Sail", title:"Vita Vitamin" },
				{ layerId:"Precious Sail", title:"Precious Mineral"},
				{ layerId:"Ice Water Sail", title:"Ice Water"},
				{ layerId:"Flex Sail", title:"Flex Protein"},
				{ layerId:"Fester Sail", title:"Fester Fatcell"},
				{ layerId:"Chargie Sail", title:"Chargie Carb"},
				{ layerId:"Star", title:"Star"}				  
			]
		},	
		{
			id:"Plank Characters",
			title:"Plank Characters",
			options:[
				{ layerId:"Mr. Tone", title:"Mr. Tone"},
				{ layerId:"Chargie", title:"Chargie Carb"},
				{ layerId:"Flex", title:"Flex Protein"},
				{ layerId:"H2O", title:"Ice Water"},
				{ layerId:"Precious", title:"Precious Mineral"},
				{ layerId:"Fester", title:"Fester Fatcell"},
				{ layerId:"Vita",title:"Vita Vitamin"}				  
			]
		},
		{
			id:"Logs",
			title:"Logs",
			options:[
				{ layerId:"Dark Oak", title:"Dark Oak"},
				{ layerId:"Greenwood", title:"Greenwood"},
				{ layerId:"Yellow Birch", title:"Yellow Birch"},
				{ layerId:"Redwood", title:"Redwood"}				  
			]
		},
		{
			id:"Flags",
			title:"Flag",
			options:[
				{ layerId:"Red Flag", title:"Red"},				  
				{ layerId:"Purple Flag", title:"Purple" },
				{ layerId:"Yellow Flag", title:"Yellow"},
				{ layerId:"Orange Flag", title:"Orange"},
				{ layerId:"Green Flag", title:"Green"},
				{ layerId:"Blue Flag", title:"Blue"}
			]
		},
		{
			id:"Hammocks",
			title:"Hammock",
			options:[
				{ layerId:"Purple Hammock", title:"Purple"},				  
				{ layerId:"Blue Hammock", title:"Blue"},
				{ layerId:"Red Hammock", title:"Red"},
				{ layerId:"Green Hammock", title:"Green"},
				{ layerId:"Orange Hammock", title:"Orange"},
				{ layerId:"Yellow Hammock", title:"Yellow"}
			]
		}		
		],
	/*
	 * Appends a raft to an element
	 */
	appendRaftTo: function (Options) {
		var options = {
				    editable:false,
					ele:null, // element to append raft to
					raftOptions:{customOptions:{},supplies:{}}, // options to customize the raft
					callback:null, // callback when the raft was appended
					raftId:'raft', // id of the raft element
					size:'Large', // raft resolution and size
					classes:'raftCustomizable'	
				};
		$.extend(options,Options);
		var raftUrl='Raft/webp/customizableRaft' + options.size + '.svg';
		if (global.isPdf) raftUrl='Raft/customizableRaft' + options.size + 'Pdf.svg';

		$.ajax({
			url: otuApp.appState.rootUrl + 'templates/op/assets/images/' + raftUrl,
			dataType: 'html',
			method: 'GET',
			success: function (data) {
				console.log('Raft - Initializing raft');
				var raftSvg = $($.parseHTML(data));
				raftSvg.attr('id',options.raftId);
					raftSvg.attr('class',options.classes);

					if (options.editable) raftSvg.addClass('raftEditable');
										
					// we store the display raft option with the raft
					raftSvg.data('raftOptions',options.raftOptions);
					
					raftSvg.find('image').each(function (e,i) {
						const newImagePath = otuApp.appState.rootUrl + 'templates/op/assets/images/Raft/webp/' + $(i).attr('xlink:href')
						$(i).attr('xlink:href',newImagePath);
					});

					console.log(options);
					console.log(raftSvg);

					$(options.ele).empty();
					$(options.ele).append(raftSvg);
					
					/*
					$('svg#' + options.raftId + ' image').each(function (e,i) {
						const newImagePath = 'templates/op/assets/images/Raft/optimizeTests/' + $(i).attr('xlink:href')
						$(i).attr('xlink:href',newImagePath);
						console.log('updated image path to ' + newImagePath);
					});
					*/

					// customize the raft
					$.each(options.raftOptions.customOptions,function(layerId,value){
						console.log(layerId);
					    raft.toggleRaftElement({
					    	raftId:options.raftId,
					    	layerId:layerId,
					    	newOption:value,
					    	animate:false
						});										
					});
					
					
					raft.fadeOutMissingSupplies(options);

					console.log('Raft - raft initialized');	



					if (typeof options.callback==="function") options.callback(raftSvg);
			}
		});

		
		/*
		// first we make sure we load the whole raft
		otuApp.preload(
				{images:[
						raftUrl
					]},
				function() {
					console.log('Raft - raft preloaded');	
					var raftSvg=$(otuApp.getPreloadedObject(raftUrl)).clone();
					// manipulate the raft
					raftSvg.attr('id',options.raftId);
					raftSvg.attr('class',options.classes);
					if (options.editable) raftSvg.addClass('raftEditable');
										
					// we store the display raft option with the raft
					raftSvg.data('raftOptions',options.raftOptions);
					
					raftSvg.find('image').each(function (e,i) {
						const newImagePath = 'templates/op/assets/images/Raft/optimizeTests/' + $(i).attr('xlink:href')
						$(i).attr('xlink:href',newImagePath);
						console.log('updated image path to ' + newImagePath);
					});

					$(options.ele).empty();
					$(options.ele).append(raftSvg);
					
					/*
					$('svg#' + options.raftId + ' image').each(function (e,i) {
						const newImagePath = 'templates/op/assets/images/Raft/optimizeTests/' + $(i).attr('xlink:href')
						$(i).attr('xlink:href',newImagePath);
						console.log('updated image path to ' + newImagePath);
					});
					

					// customize the raft
					$.each(options.raftOptions.customOptions,function(layerId,value){
						console.log(layerId);
					    raft.toggleRaftElement({
					    	raftId:options.raftId,
					    	layerId:layerId,
					    	newOption:value,
					    	animate:false
						});										
					});
					
					
					raft.fadeOutMissingSupplies(options);

					console.log('Raft - raft initialized');	



					if (typeof options.callback==="function") options.callback(raftSvg);

		});	
		*/
		
		
	},
	appendAllRaftOptionSelects : function (Options) {
		var options = {
				ele:null, // element to add the controls to 
				raftId:'raft' // id of the raft to control
			};
		$.extend(options,Options);	
		$(raft.customizableElements).each(function(){
			raft.appendSingleRaftOptionSelect({
				ele:options.ele,
				raftElement:this,
				raftId:options.raftId
			})
		});
	},
	appendSingleRaftOptionSelect:function (Options) {
		var options = {
				ele:null, // element to add the control to,
				raftElement:null, // raft element to control
				raftId:'raft' // id of the raft to control
			};
		$.extend(options,Options);	

		var raftOptions=$('svg#' + options.raftId).data('raftOptions');		
		var newEle = $('<div class="raftControl">').appendTo($(options.ele));
		var title = $('<div class="title">').appendTo(newEle);
		title.html(options.raftElement.title);
		var sel = $('<select>').appendTo(newEle);
		sel.attr('data-raft-id',options.raftId);
		sel.attr('id',options.raftElement.id)
		$(options.raftElement.options).each(function() {
			
			var option=$("<option>").attr('value',this.layerId).text(this.title);
			if (raftOptions.customOptions[options.raftElement.id]==this.layerId) option.attr('selected',true);
			if (raftOptions.canCustomize===false)  option.attr('disabled',true);
			option=sel.append(option);

		});
		sel.change(raft.raftOptionOnChange);
		
	},
	raftOptionOnChange: function() {
		var layerId=$(this).attr('id');
		var raftId=$(this).attr('data-raft-id');
		console.log('Raft - ' + layerId + ' changed');
		$(this).find("option:selected" ).each(function() {
			var newOption=$( this ).val();
		    console.log('Raft - ' + newOption + " selected");
		    raft.toggleRaftElement({
		    	raftId:raftId,
		    	layerId:layerId,
		    	newOption:newOption
		    })

		 });
	},
	toggleRaftElement(Options) {
		var options = {
				raftId:null, // the raft to manipulate
				layerId:null, // layer to set the element on
				newOption:null, // new layer to show
				animate:true // animate or not
			};
		$.extend(options,Options);	
		
		console.log('Raft - Setting ' + options.layerId + ' to ' + options.newOption + ' on ' + options.raftId + ' animate ' + options.animate.toString()) ;

		// store the new option with the raft
		var raftOptions=$('svg#' + options.raftId).data('raftOptions');

		if ( typeof raftOptions !=='undefined' ) {
			raftOptions.customOptions[options.layerId]=options.newOption;
					
			$('svg#' + options.raftId).data('raftOptions',raftOptions);
			
			if (options.animate) {
				$('svg#' + options.raftId + ' g[data-layer="' + options.layerId + '"]').fadeOut().queue(function (next){
					//$('svg g[data-layer="' + layerId + '"]').find('g[data-layer="'+ newOption+ '"]').parent().prepend($('g[data-layer="'+ newOption+ '"]'));
					$('svg#' + options.raftId + ' g[data-layer="' + options.layerId + '"] g[data-layer]').hide();
					$('svg#' + options.raftId + ' g[data-layer="' + options.layerId + '"] g[data-layer="'+options.newOption+'"]').show();
					next();
				}).fadeIn();		
			} else {
				$('svg#' + options.raftId + ' g[data-layer="' + options.layerId + '"] g[data-layer]').hide();
				$('svg#' + options.raftId + ' g[data-layer="' + options.layerId + '"] g[data-layer="'+options.newOption+'"]').show();					
			}
		} else {
			console.log('Raft - Skipping setting raft options, cannot find raft');
		}
	},
	fadeOutMissingSupplies(Options) {
		var options = {
			raftId:null, // the raft to manipulate
			animate:false,// animate or not
			opacity:"0.1"
		};

		$.extend(options,Options);	
		
		console.log('Raft - Fading out missing supplies ') ;
		
		Object.keys(raft.supplyInfo).forEach(function(key,index) {
			// key: the name of the object key
			// index: the ordinal position of the key within the object 
			if (!raft.hasSupply(key.toUpperCase(),options)) {
				if (typeof raft.supplyInfo[key].displayOptions !== 'undefined') {
					var opacity=options.opacity;
					var eles=raft.supplyInfo[key].displayOptions.elements;
					if (typeof raft.supplyInfo[key].displayOptions.opacity !== 'undefined') {
						opacity=raft.supplyInfo[key].displayOptions.opacity;
					}
					eles.forEach(function(e){
						//console.log('Setting opacity to ' + opacity + ' of ' + 'data-layer["' + e + '"]');
						$('#' + options.raftId + ' [data-layer="' + e + '"]').css('opacity',opacity);
					})

				}
			} 
		});

	},
	hasSupply:function(supply="NONE",Options) {
		var options = {
			cutOffDate: new Date(), // the raft to manipulate
		};

		$.extend(options,Options);	

		if(Object.keys(options.raftOptions.supplies).indexOf(supply.toUpperCase()) != -1 
		&& ( options.cutOffDate.getTime()>=toDate(options.raftOptions.supplies[supply.toUpperCase()].awardedOn).getTime() || options.raftOptions.supplies[supply.toUpperCase()].WON ))
		{  

		   return true
		}

		return false;
	},
	saveMyRaft:function(Options) {
		var options = {
				raftId:null, // the raft to save
				callback:null
			};
		$.extend(options,Options);		
		var raftOptions=$('svg#' + options.raftId).data('raftOptions');
		
		console.log('Raft - saving Raft');
		otuApp.triggerAjaxPost('index.php?option=com_otu_op&task=raft.saveMyRaft',
				{raftOptions:raftOptions},
				{   debug:false,
					responseType:'json',
					callback:options.callback
					}
		);
	
	}
}